import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Text,
} from '@shared/ui';

export function DialogShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.dialog.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.dialog.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">{t('uiLibrary.overlay.dialog.trigger')}</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{t('uiLibrary.overlay.dialog.modalTitle')}</DialogTitle>
              <DialogDescription>
                {t('uiLibrary.overlay.dialog.modalDescription')}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-3">
              <div className="space-y-1">
                <Text size="sm" color="muted">
                  {t('uiLibrary.overlay.dialog.fieldLabel')}
                </Text>
                <Input placeholder={t('uiLibrary.overlay.dialog.fieldPlaceholder')} />
              </div>
            </div>
            <DialogFooter>
              <Button>{t('uiLibrary.overlay.dialog.primaryAction')}</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
}
